import React, { Component } from 'react';
import "./Skills.css";


const skills = [
    { src: "https://user-images.githubusercontent.com/25181517/117447155-6a868a00-af3d-11eb-9cfe-245df15c9f3f.png", alt: "JavaScript Icon", title: "JavaScript", description: "React, Node.js, Express.js, Redux.js, React Testing Library, Jest" },
    { src: "https://user-images.githubusercontent.com/25181517/183423507-c056a6f9-1ba8-4312-a350-19bcbc5a8697.png", alt: "Python Icon", title: "Python", description: "Flask, unittest" },
    { src: "https://user-images.githubusercontent.com/25181517/183898674-75a4a1b1-f960-4ea9-abcb-637170a00a75.png", alt: "CSS Icon", title: "CSS", description: "Bootstrap, Flexbox, Grid, Figma, Adobe Creative Cloud" },
    { src: "https://user-images.githubusercontent.com/25181517/192158954-f88b5814-d510-4564-b285-dff7d6400dad.png", alt: "HTML Icon", title: "HTML" },
    { src: "https://user-images.githubusercontent.com/25181517/183896128-ec99105a-ec1a-4d85-b08b-1aa1620b2046.png", alt: "SQL Icon", title: "SQL" },
];

class Skills extends Component {
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row py-lg-5">
                        <div className="col-lg-9 col-md-8 mx-auto">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Stack_Overflow_icon.svg/768px-Stack_Overflow_icon.svg.png" alt="Stack icon" height="180"/>     
                            <p>
                                {skills.map((skill, index) => (
                                    <React.Fragment key={index}>
                                        <img src={skill.src} alt={skill.alt} width="30"/> - <strong>{skill.title}</strong> <i>{skill.description}</i> <br/>
                                    </React.Fragment>
                                ))}
                            </p>
                            <hr />
                            <p> With a background in education and media, I pivoted to coding through self-learning in June 2023. I proudly graduated with a distinction in Code First Girls' Full Stack Development NanoDegree in January 2024. Specialising in creating user-friendly and visually appealing applications, I bring a unique blend of skills to deliver impactful digital experiences. </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Skills;